import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Iconbtn from '../../../common/Iconbtn'
import { FiUpload } from 'react-icons/fi'
import { updateDisplayPicture } from '../../../../services/operations/SettingsAPI'

const ChangeProfilePic = () => {

    const {token} = useSelector((state) => state.auth)
    const {user} = useSelector((state) => state.profile)
    const fileInputRef = useRef(null)
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false)
    const [imageFile, setImageFile] = useState(null)
    const [previewSource, setPreviewSource] = useState(null)
    
    const handleClick = () => {
        fileInputRef.current.click()
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0]
        if(file) {
            setImageFile(file)
            previewFile(file)
        }
    }

    const previewFile = (file) => {
        const reader = new FileReader() 
        reader.readAsDataURL(file)
        reader.onloadend = () => {
            setPreviewSource(reader.result)
        }
    }

    const handleFileUpload = () => {
        try {
            console.log("Uploading...")
            setLoading(true)
            const formData = new FormData()
            formData.append("displayPicture", imageFile)
            //console.log("Form Data ", formData)
            dispatch(updateDisplayPicture(token,formData)).then(() => {
                setLoading(false)
            })

            
        } catch (error) {
            console.log("Error while uploading...", error.message)
        }
    }

    useEffect(() => {
        if(imageFile) {
            previewFile(imageFile)
        }
    }, [imageFile])
  return (
    <>
        <div className='flex items-center justify-between rounded-md border-[1px] border-richblack-700 bg-richblack-800 p-3 py-5 lg:p-8 lg:px-12 text-richblack-5'>
            <div className='flex items-center gap-x-7'>
                <img 
                    src={previewSource || user?.images}
                    alt={`profile-${user?.firstName}`}
                    className=' aspect-square w-[78px] rounded-full object-cover' 
                />
                <div className='space-y-2'>
                    <p>Change Profile Picture</p>
                    <div className='flex gap-3'>
                        <input 
                            type='file'
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            className='hidden'
                            accept='image/png, image/gif, image/jpeg'
                        />
                        <button
                            onClick={handleClick}
                            disabled={loading}
                            className='cursor-pointer rounded-md bg-richblack-700 py-2 px-5 font-semibold text-richblack-25'
                        >
                            Select
                        </button>
                        <Iconbtn 
                            text={loading ? "Uploading...." : "Upload"}
                            onclick={handleFileUpload}
                        >
                            {
                                !loading && (
                                    <FiUpload className='text-lg text-richblack-900'/>
                                )
                            }
                        </Iconbtn>
                        
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default ChangeProfilePic